module.exports = __webpack_public_path__ + "static/img/1.5768661.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/eng/1.png
// module id = kpPq
// module chunks = 0